import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { get } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
    extraErrorMeta = {};
    disableTimeout = false;
    code = '\u2022';

    constructor(private toasterService: ToastrService) { }

    public handleError(error: HttpErrorResponse) {
        let errorTitle = `${error.status}`;
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {
            errorTitle = 'Client Side Error';
            errorMessage = `An error occurred: ${error.error.message}`;
            this.disableTimeout = false;
        } else {
            const backendMessage =
                get(error, 'error.message') ||
                get(error, 'error.status.message') ||
                '';

            switch (error.status) {
                case 400:
                    errorTitle = '400 - Bad Request';
                    errorMessage = backendMessage || `${this.code} Invalid request.`;
                    this.disableTimeout = true;
                    break;

                case 401:
                    errorTitle = '401 - Unauthorized';
                    errorMessage =
                        backendMessage ||
                        `${this.code} Access is denied due to invalid credentials.`;
                    this.disableTimeout = true;
                    break;

                case 403:
                    errorTitle = '403 - Forbidden';
                    errorMessage =
                        backendMessage ||
                        `${this.code} You do not have permission to access the requested resource.`;
                    this.disableTimeout = true;
                    break;

                case 404:
                    errorTitle = '404 - Not Found';
                    errorMessage =
                        backendMessage ||
                        `${this.code} The requested resource does not exist.`;
                    this.disableTimeout = false;
                    break;

                case 406:
                    errorTitle = '406 - Not Acceptable';
                    errorMessage = backendMessage || `${this.code} Not accepted by server.`;
                    this.disableTimeout = false;
                    break;

                case 412:
                    errorTitle = '412 - Precondition Failed';
                    errorMessage = backendMessage || `${this.code} Precondition failed.`;
                    this.disableTimeout = true;
                    break;

                case 500:
                    errorTitle = '500';
                    errorMessage = backendMessage || `${this.code} Internal Server Error.`;
                    this.disableTimeout = false;
                    break;

                case 503:
                    errorTitle = '503 - Service Unavailable';
                    errorMessage =
                        backendMessage ||
                        `${this.code} The requested service is not available.`;
                    this.disableTimeout = false;
                    break;

                default:
                    errorTitle = 'Unknown Server Error';
                    errorMessage =
                        backendMessage ||
                        `${this.code} Something went wrong. Try again later.`;
                    this.disableTimeout = false;
                    break;
            }
        }

        if (get(error, 'error.errors')?.length) {
            const errors = get(error, 'error.errors').join('<br/>' + this.code + ' ');
            errorMessage = `${errorMessage}<br/>${this.code} ${errors}`;
            this.disableTimeout = true;
        }

        this.setErrorMetaData();
        this.toasterService.error(errorMessage, errorTitle, this.extraErrorMeta);
    }

    private setErrorMetaData() {
        this.extraErrorMeta = {
            timeOut: this.disableTimeout ? 0 : 4000,
            extendedTimeOut: this.disableTimeout ? 0 : 1000,
            tapToDismiss: true,
            closeButton: true,
            progressBar: true,
            enableHtml: true,
        };
    }
}
